"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageService = exports.DEFAULT_OPTIONS = exports.UploadRequestMode = void 0;

var axios_1 = __importDefault(require("axios"));
/** Types of upload requests. */


var UploadRequestMode;

(function (UploadRequestMode) {
  /**
   * Form data mode.
   * @remarks
   * This assumes you're uploading files via FormData and a x-www-urlencoded Content Type. Usually
   * this means you're also sending data via a POST request.
   */
  UploadRequestMode["FormData"] = "FORM_DATA";
  /**
   * Basic mode.
   * @remarks
   * This assumes you're uploading files directly in the request body, with the content type
   * referencing the type of content you're uploading. Usually, this means you're also sending data
   * via a PUT (but sometimes POST) request.
   */

  UploadRequestMode["Basic"] = "BASIC";
})(UploadRequestMode = exports.UploadRequestMode || (exports.UploadRequestMode = {}));
/** Default options for a storage service. */


exports.DEFAULT_OPTIONS = {};
/**
 * Store, retrieve, and query files on a third-party file storage provider.
 *
 * @remarks
 * The storage service is responsible for interfacing with services like AWS S3 or Wasabi. It
 * provides a universal interface for working with these providers.
 *
 * Because it provides this universal interface, we should be able to easily swap out one provider
 * for the other, so long as we've already transferred the existing files between them.
 */

var StorageService = /*#__PURE__*/function () {
  function StorageService(options) {
    _classCallCheck(this, StorageService);

    this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
  }
  /**
   * Uploads a file to the service.
   * @param options - the options to pass to the provider
   */


  _createClass(StorageService, [{
    key: "uploadFile",
    value: function uploadFile(_a) {
      var contents = _a.contents,
          rest = __rest(_a, ["contents"]);

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var signedRequest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getSignedUploadUrl(Object.assign(Object.assign({}, rest), {
                  requestMode: UploadRequestMode.Basic
                }));

              case 2:
                signedRequest = _context.sent;
                _context.next = 5;
                return (0, axios_1.default)({
                  method: 'PUT',
                  url: signedRequest.signedUrl,
                  headers: signedRequest.data,
                  data: contents
                });

              case 5:
                return _context.abrupt("return", signedRequest);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Gets the contents of a file from the storage service.
     * @param fetchOptions the options to pass to getSignedFetchUrl()
     * @returns the file contents, as a string
     */

  }, {
    key: "getFileContents",
    value: function getFileContents(fetchOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var fetchUrl, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getSignedFetchUrl(fetchOptions);

              case 2:
                fetchUrl = _context2.sent;
                _context2.next = 5;
                return (0, axios_1.default)({
                  method: 'GET',
                  url: fetchUrl.signedUrl,
                  headers: fetchUrl.requireHeaders,
                  responseType: 'text'
                });

              case 5:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return StorageService;
}();

exports.StorageService = StorageService;